/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} InsertInputs */

const en_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert`)
};

const fr_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion`)
};

const de_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen`)
};

const it_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserire`)
};

const ru_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставлять`)
};

const es_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar`)
};

const zh_cn2_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入`)
};

const ja_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入れる`)
};

const hi_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डालना`)
};

const pt_pt2_insert = /** @type {(inputs: InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir`)
};

/**
* | output |
* | --- |
* | "Insert" |
*
* @param {InsertInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert = /** @type {((inputs?: InsertInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<InsertInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert(inputs)
	if (locale === "de") return de_insert(inputs)
	if (locale === "it") return it_insert(inputs)
	if (locale === "ru") return ru_insert(inputs)
	if (locale === "es") return es_insert(inputs)
	if (locale === "zh-CN") return zh_cn2_insert(inputs)
	if (locale === "ja") return ja_insert(inputs)
	if (locale === "hi") return hi_insert(inputs)
	if (locale === "pt-PT") return pt_pt2_insert(inputs)
	return en_insert(inputs)
});